import dayjs from "dayjs"

export const ClientWorkflowsTransformer = response => {
  const transformTimeline = (timeline = []) => {
    return timeline.map(stage => {
      const stageDeadlineDate = dayjs(stage?.assignedDate).add(stage?.turnAroundTime, "day")
      const pendingDate = !!(stage?.status === "pending" && stage?.currentStage) ? stageDeadlineDate : ""
      return {
        ...stage,
        date:
          stage?.status === "approved"
            ? stage?.completionDate
            : stage?.status === "in_progress"
              ? stageDeadlineDate
              : stage?.status === "rejected"
                ? stage?.rejectedDate
                : stage?.status === "pending"
                  ? pendingDate
                  : stage?.status === "skipped"
                    ? stage?.skippedDate
                    : "",
      }
    })
  }
  let data = response?.data?.map(item => {
    const stageDeadline = dayjs(item?.currentStage?.assignedDate).add(item?.currentStage?.turnAroundTime, "day")
    return {
      ...item,
      isOverdue: Math.max(0, dayjs().diff(dayjs(item?.dueDate), "day")),
      isCompletedAfterDue: Math.max(0, dayjs(item?.completedDate).diff(dayjs(item?.dueDate), "day")),
      isRejectedAfterDue: Math.max(0, dayjs(item?.rejectedDate).diff(dayjs(item?.dueDate), "day")),
      timeline: transformTimeline(item?.timeline),
      isStageOverDue: Math.max(0, dayjs().diff(dayjs(stageDeadline), "day")),
      stageDeadline,
    }
  })
  return {
    ...response,
    data,
    statistics: {
      pending: response?.statistics?.pending,
      in_progress: response?.statistics?.in_progress,
      completed: response?.statistics?.completed,
      rejected: response?.statistics?.rejected,
      all: response?.statistics?.all,
    },
  }
}
